export const attendanceDictionary = {
  iRatingResult: 'Guruhdagi reyting natijasi:',
}
